import React, { useState, useEffect } from "react";

const MultiPhotos = ({ user }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const photos = user?.photos || [];

  // Auto-rotate photos
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [photos.length]);

  // Swipe handlers
  const handleSwipe = (direction) => {
    if (direction === "left") {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
    } else {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? photos.length - 1 : prevIndex - 1
      );
    }
  };

  if (!photos || photos.length === 0) {
    return (
      <div className="p-2 text-center text-gray-400 text-sm">No photos</div>
    );
  }

  return (
    <div className="w-full relative bg-gray-900 rounded-lg overflow-hidden">
      {/* Photos container */}
      <div
        className="relative h-48 overflow-hidden"
        onClick={() => handleSwipe("left")}
      >
        {photos.map((photo, index) => (
          <div
            key={photo.id}
            className="absolute w-full h-full transition-all duration-700 ease-in-out"
            style={{
              opacity: index === currentIndex ? 1 : 0,
              transform: `scale(${index === currentIndex ? 1 : 0.95})`,
            }}
          >
            <img
              src={photo.url}
              alt={`${user?.name || ""} ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}

        {/* Subtle photo counter */}
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white text-xs px-2 py-1 rounded-full">
          {currentIndex + 1}/{photos.length}
        </div>
      </div>

      {/* Minimal indicator dots */}
      <div className="flex justify-center py-2 space-x-1">
        {photos.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-1 h-1 rounded-full focus:outline-none ${
              index === currentIndex ? "bg-white" : "bg-gray-600"
            }`}
            aria-label={`Go to photo ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default MultiPhotos;
